import enUS from './en-us'
import faIr from './fa-ir'

export default {
  'en-us': enUS,
  'fa-ir': faIr
}
